import { PostStatus } from '../../constants';
import { DeclinedReason, PostUI } from '../../types';

export const hasPostCardStatus = (post: PostUI): boolean => {
    const { status, declinedReason, monetizationEnabled, products } = post;

    if (status === PostStatus.MODERATION) {
        return true;
    }

    if (status === PostStatus.LIMITED) {
        return true;
    }

    if (declinedReason === DeclinedReason.NEED_PRODUCT) {
        return true;
    }

    if (status === PostStatus.DECLINED) {
        return true;
    }

    const hasUnavailableProducts = products?.items.some((product) => product.isUnavailable);

    if (hasUnavailableProducts) {
        return true;
    }

    if (status === PostStatus.DRAFT) {
        return true;
    }

    if (monetizationEnabled) {
        return true;
    }

    return false;
};
